import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Return: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.46324 4.06739C6.79797 3.74696 6.79797 3.22744 6.46324 2.90701C6.1285 2.58658 5.58579 2.58658 5.25105 2.90701L2.25105 5.7788C1.91632 6.09924 1.91632 6.61875 2.25105 6.93919L5.25105 9.81098C5.58579 10.1314 6.1285 10.1314 6.46324 9.81098C6.79797 9.49055 6.79797 8.97103 6.46324 8.6506L4.92647 7.17951H9.92857C11.2304 7.17951 12.2857 8.18974 12.2857 9.43592C12.2857 10.6821 11.2304 11.6923 9.92857 11.6923H8C7.52662 11.6923 7.14286 12.0597 7.14286 12.5128C7.14286 12.966 7.52662 13.3334 8 13.3334H9.92857C12.1772 13.3334 14 11.5885 14 9.43592C14 7.28343 12.1772 5.53848 9.92857 5.53848H4.92647L6.46324 4.06739Z"
      fill="currentColor"
    />
  </svg>
);
